<template>
  <layout ref="layout" :share="false" :title="title" @titleInit="titleInit">
    <div class="content-menu" ref="menu" :style="{ top: titleHeight + 'px' }">
      <search-screen :screenOptions="screenOptions" @change="searchResult"></search-screen>
    </div>
    <div class="search-list" :style="{ paddingTop: paddingTop + 'px' }">
      <div class="search-num flex-justify-bcenter" v-if="total > 0">
        <div>
          为您找到 <span class="red">{{ total }}</span> 家关联企业
        </div>
        <span class="red" @click="onExport">导出数据</span>
      </div>
      <div class="list">
        <yq-list
          ref="yqlist"
          :url="url"
          :needCancel="true"
          :showFinish="false"
          :pagesize="10"
          :params="params"
          @updateList="updateList"
        >
          <list-item
            class="company-item"
            v-for="item in list"
            :key="item.org_id"
            :item="item"
            :title="title"
            @showPhone="showPhone"
          ></list-item>
        </yq-list>
      </div>
    </div>
    <phone-action
      :visible.sync="phoneActionVisible"
      :isVip="isVip"
      :tels="phoneActionItem.tel_list"
    />
  </layout>
</template>

<script>
import layout from '@components/layout/default.vue';
import SearchScreen from '../components/search-screen.vue';
import ListItem from '../components/company-item.vue';
import PhoneAction from '../components/phoneAction.vue';
import { customerEnterpriseList } from '@api/data-market';
import { getArea } from '@utils/business-utils';
import { jumpExportData, sourcePage, exportType } from '@utils/export-data';

export default {
  components: {
    layout,
    SearchScreen,
    ListItem,
    PhoneAction,
  },
  data() {
    return {
      url: customerEnterpriseList,
      title: this.$route.query.name || '',
      // shareInfo: {
      //   url:
      //     window.location.href +
      //     `?isShowAppBar=false&isShowStatusBar=false&share=${isHeXin() ? 'hexin' : 'yjt'}`,
      //   title: '园区数据',
      //   content: '覆盖2.4亿企业信息，免费查企业查股东查关系，快来体验！',
      // },
      titleHeight: 0,
      list: [],
      total: 0,
      params: {
        code: this.$route.query.code,
        sort_field: null,
        sort_value: null,
        area_code: null,
      },
      paddingTop: 0,
      phoneActionVisible: false,
      phoneActionItem: {},
      screenOptions: [],
      isVip: false,
    };
  },
  mounted() {
    this.initScreen();
    this.$nextTick(() => {
      this.paddingTop = this.$refs.menu.offsetHeight;
    });
  },
  methods: {
    onExport() {
      jumpExportData(
        this.title,
        exportType.find_customer,
        sourcePage.find_customer,
        this.total,
        this.params
      );
    },
    async initScreen() {
      this.screenOptions = [
        {
          key: 'area_code',
          title: '全部区域',
          titleDesc: '区域',
          type: 'treeSelect',
          hasValue: false,
          single: true,
          childs: [],
          saveSelected: [],
          selected: [],
          defaultSelected: [{ id: '', name: '全部', select: true }],
        },
        {
          key: 'sort',
          title: '智能排序',
          titleDesc: '智能排序',
          type: 'radioItems',
          hasValue: false,
          childs: [
            { name: '智能排序', id: null },
            { name: '企业注册资金由高到低', id: 'capital_rmb-desc' },
            { name: '企业注册资金由低到高', id: 'capital_rmb-asc' },
            { name: '企业注册时间由早到晚', id: 'establish_time-asc' },
            { name: '企业注册时间由晚到早', id: 'establish_time-desc' },
          ],
        },
      ];
      const list = await getArea(this);
      this.screenOptions[0].childs = list;
    },
    showPhone(val) {
      this.phoneActionVisible = true;
      this.phoneActionItem = val;
    },
    titleInit(height) {
      this.titleHeight = height;
    },
    updateList(data) {
      this.list = data.list;
      this.total = data.res.data.total || 0;
      this.isVip = data.res.data.is_vip;
      this.$refs.layout.showBottom = this.list.length !== 0;
    },
    // 搜索
    searchResult(type, val) {
      if (type === 'sort') {
        // 排序进行特殊处理
        let key = null,
          v = null;
        if (val) {
          [key, v] = val.split('-');
        }
        this.params.sort_field = key;
        this.params.sort_value = v;
      } else {
        this.params[type] = val ?? null;
      }
      this.$refs.yqlist.getList();
    },
  },
};
</script>

<style lang="less" scoped>
.content-menu {
  width: 100%;
  box-sizing: border-box;
  position: fixed;
  z-index: 5;
}
.search-list {
  padding: 0 12px;
  .search-num {
    padding: 14px 0 2px;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.32);
    line-height: 20px;
    .red {
      color: #f0330d;
    }
  }
}
.company-item {
  margin: 10px 0 0 !important;
  padding: 0 12px !important;
}
</style>
